var React = require('react');

function ArrowIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.05721 8.96118C8.93481 8.86222 8.87492 8.70337 8.87492 8.54191C8.87492 8.38045 8.93596 8.22212 9.05802 8.09998L11.5338 5.62524H0.958252C0.6132 5.62524 0.333252 5.34399 0.333252 4.97681C0.333252 4.65389 0.6132 4.37524 0.958252 4.37524H11.5338L9.05903 1.9005C8.81489 1.65636 8.81489 1.26092 9.05903 1.01665C9.30317 0.77238 9.69862 0.77251 9.94289 1.01665L13.4846 4.55832C13.7287 4.80246 13.7287 5.1979 13.4846 5.44217L9.94289 8.98384C9.69783 9.22681 9.302 9.22681 9.05721 8.96118Z","fill":"#424242"}));
}

ArrowIconInline.defaultProps = {"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none"};

module.exports = ArrowIconInline;

ArrowIconInline.default = ArrowIconInline;
